import React from 'react'
import { Icon } from 'antd';


export default function ErrorScreen() {
  return (
    <div style={{textAlign:'center'}}>
        <Icon type="frown" style={{fontSize: 60, color:'#ecbb00'}} />
        <div style={{marginTop:10, fontSize:16, fontWeight:'bold', color:'#999'}}>Desculpe, tivemos uma falha no processamento...</div>

        <div><span style={{fontSize:16, marginTop: 15}} className="btn btn-link" onClick={() => document.location.reload(true)}>Tentar novamente</span></div>
    </div>
  )
} 
